import React, { useEffect, useState } from "react"
import { Typography, Box, styled, useTheme } from "@mui/material"
import { MdCloudUpload } from "react-icons/md"
import { LoadingButton } from "@mui/lab"
import { Grid } from "@mui/system"
import { ClientsService } from "../../services/clients"
import { useLocation, useNavigate } from "react-router-dom"
import useAuth from "../../context/auth"

export const StyledUploadBox = styled(Box)(({ theme }) => ({
    width: "100%",
    height: "20.08rem",
    border: `2px dashed ${theme.palette.primary.main}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    borderRadius: "10px",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: theme.palette.action.hover,
    },
    marginBottom: "2rem"
}))

export const UploadDocument = () => {
    const { palette } = useTheme()
    const { user, handleModal } = useAuth()
    const { state } = useLocation()
    const navigate = useNavigate()


    const [documentFile, setDocumentFile] = useState<null | File>(null)
    const [loading, setLoading] = useState(false)

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0]
        if (!file) return

        const maxSizeInMB = 10
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024

        if (file.size > maxSizeInBytes) {
            handleModal(true, {
                message: `O arquivo selecionado excede o limite de ${maxSizeInMB}MB.`,
                type: "warning"
            })
            event.target.value = ''
            return
        }

        if (file) {
            console.log("Arquivo selecionado:", file)
            setDocumentFile(file)
        }
    }

    const handleBoxClick = () => {
        const input = document.getElementById("upload-input") as HTMLInputElement
        if (input) {
            input.click()
        }
    }

    const uploadDocument = () => {
        setLoading(true)

        ClientsService.uploadDocument(documentFile as File)
            .then(() => navigate("/cliente/fotos", {
                state
            }))
            .catch(() => setLoading(false))
    }

    useEffect(() => {
        if (!state?.value) navigate(-1)
    }, [])

    return (
        <>
            <Typography fontWeight={700} fontSize={"3.2rem"} p={0}>
                Comprovante de residência
            </Typography>

            <Typography
                fontWeight={400}
                fontSize={"1.6rem"}
                sx={{ opacity: 0.5, maxWidth: "26.6rem" }}
                p={0}
                mb={2}
            >
                Para continuar, tire uma foto do seu comprovante de residência (<strong>conta de água, internet, telefone ou de energia</strong>), do endereço <strong style={{ color: palette.primary.main }}>{user?.data?.address?.street}, {user?.data?.address?.number}, {user?.data?.address?.district}</strong> e anexe abaixo
            </Typography>

            <StyledUploadBox onClick={handleBoxClick}>
                <MdCloudUpload size={52} color={palette.primary.main} />

                <Typography fontSize={"1.6rem"} sx={{ opacity: .5 }} textAlign={"center"}>
                    {documentFile && documentFile.name}
                    {!documentFile && <>Clique aqui para anexar o arquivo<br />(.jpg .jpeg .png .pdf)</>}
                </Typography>

                {documentFile &&
                    <Typography fontWeight={500} fontSize={"1.6rem"} sx={{ textDecoration: "underline", opacity: 0.5 }}>
                        Se prefefir, substitua o arquivo
                    </Typography>
                }

                <input
                    id="upload-input"
                    type="file"
                    style={{ display: "none" }}
                    accept=".jpg,.jpeg,.png,.pdf"
                    onChange={handleFileChange}
                />
            </StyledUploadBox>

            <Grid
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
            >
                <LoadingButton
                    variant="contained"
                    disabled={!documentFile || loading}
                    loading={loading}
                    sx={{
                        height: "5rem",
                        ... (!(!documentFile || loading) && {
                            animation: "pulse 1.5s infinite"
                        })
                    }}
                    onClick={uploadDocument}
                >
                    Enviar comprovante
                </LoadingButton>
            </Grid>

        </>
    )
}
